import {
  ContextBubble,
  Form,
  IContextBubbleProps,
} from '@homex/se-react-components';
import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';
import { containerSmall, containerTall } from 'styles/layout';
import { eyebrowThin } from 'styles/typography';
import { IWithThemeProps } from 'typings';

interface IContextBubbleCustomProps {
  hasStreet2: boolean;
}

interface IFieldsetProps {
  isMuted?: boolean;
}

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const Buttons = styled.div`
  ${containerSmall}

  margin-top: 13px;
`;

export const Container = styled.div`
  ${containerSmall}

  margin-top: 33px;
  text-align: left;
`;

export const CorrectedAddresses = styled.div`
  line-height: 1;
  margin: 0 0 2px 14px;
`;

export const Fieldset = styled.fieldset<IFieldsetProps>`
  border: 0;
  margin: 0;
  padding: 0;

  ${({ isMuted }) => `
    opacity: ${isMuted ? 0.8 : 1};
  `}
`;

export const FieldsetMutedContainer = styled.div`
  border-radius: 6px;
  line-height: 1;
  margin: 15px 0 0;
  padding: 13px;
  position: relative;

  ${({ theme }: IWithThemeProps) => `
    background-color: ${theme.bottomBackgroundMuted};
  `}
`;

export const Legend = styled.legend`
  ${eyebrowThin}

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

const ContextBubbleWithProps = ({
  hasStreet2: _hasStreet2,
  ...props
}: IContextBubbleCustomProps & IContextBubbleProps) => {
  return <ContextBubble {...props} />;
};

export const ContextBubbleCustom = styled(
  ContextBubbleWithProps,
)<IContextBubbleCustomProps>`
  bottom: 92px;
  right: 0;
  width: 240px;

  ${({ hasStreet2 }) => `
    bottom: ${hasStreet2 ? 117 : 92}px;
  `}

  ${large`
    left: 61px;
    width: 334px;
  `}
`;
